/**
 * 全局工具类方法
 */
export default {
  install(Vue, options) {
    // 计算每个sku后面有多少项
    Vue.prototype.getLevels = function (tree) {
      let level = [];
      for (let i = tree.length - 1; i >= 0; i--) {
        if (tree[i + 1] && tree[i + 1].leaf) {
          level[i] = tree[i + 1].leaf.length * level[i + 1] || 1;
        } else {
          level[i] = 1;
        }
      }
      return level;
    }

    /**
     * 笛卡尔积运算
     * @param  {[type]} tree   [description]
     * @param  {Array}  stocks [description]
     * @return {[type]}        [description]
     */
    Vue.prototype.flatten = function (tree, stocks = [], options) {
      let {
        optionValue = 'id', optionText = 'text'
      } = options || {};
      let result = [];
      let skuLen = 0;
      let stockMap = {}; // 记录已存在的stock的数据
      const level = this.getLevels(tree);
      if (tree.length === 0) return result;
      tree.forEach(sku => {
        // console.log(tree,'tree')
        const {
          leaf
        } = sku;
        if (!leaf || leaf.length === 0) return true;
        skuLen = (skuLen || 1) * leaf.length;
      });
      // console.log(tree,'sku')
      // 根据已有的stocks生成一个map
      stocks.forEach(stock => {
        let {
          skus,
          ...attr
        } = stock;
        stockMap[skus.map(item => `${item.k_id}_${item.v_id}`).join('|')] = attr;
      });

      for (let i = 0; i < skuLen; i++) {
        let skus = [];
        let mapKey = [];
        // console.log(skuLen,'111')
        tree.forEach((sku, column) => {
          const {
            leaf
          } = sku;
          let item = {};
          if (!leaf || leaf.length === 0) return true;
          if (leaf.length > 1) {
            let row = parseInt(i / level[column], 10) % leaf.length;
            item = tree[column].leaf[row];
            // console.log(leaf,'leaf')
          } else {
            item = tree[column].leaf[0];
          }
          // console.log('2222222------------',sku[optionValue],sku[optionText],!sku[optionValue], !item[optionValue])
          // if (!sku[optionValue] || !item[optionValue]) return;
          // console.log('33333------------',sku[optionValue],sku[optionText])
          mapKey.push(`${sku[optionValue]}_${item[optionValue]}`);
          // console.log(item.picture,'text')
          if (typeof item.picture == 'undefined') {
            // console.log('111')
            skus.push({
              key: sku[optionText],
              value: item[optionText],
              picture: '',
            });
          } else {
            // console.log('222')
            // console.log(item.picture.length!=0,'33')
            skus.push({
              key: sku[optionText],
              value: item[optionText],
              picture: item.picture.length != 0 ? item.picture[0].url : '',
            });
          }
          // skus.push({
          //   // k_id: sku[optionValue],
          //   key: sku[optionText],
          //   // v_id: item[optionValue],
          //   value: item[optionText],
          //   picture:item.picture!=[]?item.picture[0].url:'',
          // });
        });
        let { ...data
        } = stockMap[mapKey.join('|')] || {};
        // 从map中找出存在的sku并保留其值
        result.push({ ...data,
          skus
        });
      }
      return result;
    }



    /**
     * 判断两个sku是否相同
     * @param  {[type]}  prevSKU [description]
     * @param  {[type]}  nextSKU [description]
     * @return {Boolean}         [description]
     */
    Vue.prototype.isEqual = function (prevSKU, nextSKU, options) {
      let {
        optionValue = 'id'
      } = options || {};
      return (
        nextSKU.length === prevSKU.length &&
        nextSKU.every(({
          leaf = []
        }, index) => {
          let prevLeaf = prevSKU[index].leaf || [];
          return (
            prevSKU[index][optionValue] === nextSKU[index][optionValue] &&
            leaf.length === prevLeaf.length &&
            leaf.map(item => item[optionValue]).join(',') ===
            prevLeaf.map(item => item[optionValue]).join(',')
          );
        })
      );
    }


    /**
     * 批量更改数组Key名
     * @param  {[type]} list [description]
     * @param  {[type]} rule [description]
     * @return {[type]}      [description]
     */
    Vue.prototype.listChangeKey = function (list, rule) {

      for (var i in list) {
        for (var key in rule) {
          if (list[i][rule[key].old]) {
            list[i][rule[key].new] = list[i][rule[key].old]
            delete list[i][rule[key].old];
          }
        }
      }
      return list

    }
    /**
     *列表转换为树状
     * @param  {[type]} list    [description]
     * @param  {Number} pid [description]
     * @return {[type]}         [description]
     */
    Vue.prototype.listToTree = function (list, pid) {

      let ret = [];
      for (let i in list) {
        if (list[i].parent_id == pid) {
          list[i].children = this.listToTree(list, list[i].value);
          ret.push(list[i]);
        }
      }
      return ret; //递归结束后返回结果
    }

    /**
     * 区域联动转换为树状
     * @param  {[type]} data    [description]
     * @param  {Number} pid [description]
     * @return {[type]}         [description]
     */
    Vue.prototype.regionToTree = function (data, pid) {

      data.districts = this.listChangeKey(data.districts, [{
        "old": "id",
        "new": "value"
      }, {
        "old": "title",
        "new": "label"
      }])
      data.citys = this.listChangeKey(data.citys, [{
        "old": "id",
        "new": "value"
      }, {
        "old": "title",
        "new": "label"
      }])
      data.provinces = this.listChangeKey(data.provinces, [{
        "old": "id",
        "new": "value"
      }, {
        "old": "title",
        "new": "label"
      }])
      //地区添加到市
      for (let i in data.districts) {
        // console.log(data.districts[i])
        // data.citys[data.districts[i].parent_id - 1].children = []
        if (data.citys[data.districts[i].parent_id - 1].children == undefined) {
          data.citys[data.districts[i].parent_id - 1].children = []
          data.citys[data.districts[i].parent_id - 1].children.push(data.districts[i])
        } else {
          data.citys[data.districts[i].parent_id - 1].children.push(data.districts[i])
        }
        // console.log(data.citys[data.districts[i].parent_id - 1])
        // data.citys[data.districts[i].parent_id - 1].children.push(data.districts[i])
      }

      //市添加到省
      for (let i in data.citys) {
        if (data.provinces[data.citys[i].parent_id - 1].children == undefined) {
          data.provinces[data.citys[i].parent_id - 1].children = []
          data.provinces[data.citys[i].parent_id - 1].children.push(data.citys[i])
        } else {
          data.provinces[data.citys[i].parent_id - 1].children.push(data.citys[i])
        }
      }

      return data.provinces; //递归结束后返回结果

    }

    /**
     * 处理图片url
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    Vue.prototype.HandleUrl = function (data) {

      let src
      if (data.indexOf("http") < 0) {
        src = 'http://' + data
      } else {
        src = data
      }

      return src;

    }
    /**
     * 处理帮助参数
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    Vue.prototype.HandleHelpParams = function (data) {
      let params
      // 商品管理
       if (data.routerName == 'goods') {
        return params = 'pannel_goods_list'
      }
      // 商品创建
      else if (data.routerName == 'goods-add') {
        return params = 'pannel_goods_create'
      }
      // 商品分组
      else if (data.routerName == 'goods-class') {
        return params = 'pannel_goods_group'
      }
        // 风格主题
        else if (data.routerName == 'goods-class') {
          return params = 'pannel_theme'
        }
         // 店铺主题配色
         else if (data.routerName == 'shop-theme-set-color') {
          return params = 'pannel_store_theme_color'
        }
         // 店铺主题导航
         else if (data.routerName == 'shop-theme-set-menu') {
          return params = 'pannel_store_theme_menu'
        }
         // 店铺主题列表
         else if (data.routerName == 'shop-theme-set-history') {
          return params = 'pannel_store_theme_list'
        }
         // 店铺主题页面列表
         else if (data.routerName == 'shop-theme-set-pages') {
          return params = 'pannel_store_theme_page'
        }
         // 店铺主题页面编辑
         else if (data.routerName == 'shop-pages-add-edge') {
          return params = 'pannel_store_theme_page_edit'
        }
      // 订单概况
      else if (data.routerName == 'order') {
        return params = 'pannel_order_statistics'
      }
      // 订单列表
      else if (data.routerName == 'order-all') {
        return params = 'pannel_order_list'
      }
        // 订单详情
        else if (data.routerName == 'order-detailorder-detail') {
          return params = 'pannel_order_detail'
        }
      // 售后维权列表
      else if (data.routerName == 'order-after-sale') {
        return params = 'pannel_refund_list'
      } 
        // 售后维权详情
        else if (data.routerName == 'sale-detail') {
          return params = 'pannel_refund_detail'
        } 
      // 客户管理
      else if (data.routerName == 'user') {
        return params = 'panel_user_list'
      }
      // 标签管理
      else if (data.routerName == 'user-label') {
        return params = 'pannel_user_tag_list'
      }
      // 我的资产
      else if (data.routerName == 'assets') {
        return params = 'pannel_asset'
      }
       // 提现
       else if (data.routerName == 'assets-withdra') {
        return params = 'pannel_asset_withdraw'
      }
      // 提现记录
      else if (data.routerName == 'assets') {
        return params = 'pannel_asset_withdraw_record'
      }
      // 交易记录
      else if (data.routerName == 'assets-record') {
        return params = 'pannel_asset_trade'
      }
      // 对账单
      else if (data.routerName == 'assets-bill') {
        return params = 'pannel_asset_bill'
      }

      // 拼团
      else if (data.routerName == 'marketing-groupon') {
        return params = 'pannel_marketing_groupon_list'
      }
      // 拼团创建
      else if (data.routerName == 'marketing-groupon-add') {
        return params = 'pannel_marketing_groupon_create'
      }
      // 秒杀
      else if (data.routerName == 'marketing-second') {
        return params = 'pannel_marketing_skill_list'
      }
       // 秒杀创建
       else if (data.routerName == 'marketing-second-add') {
        return params = 'pannel_marketing_skill_create'
      }
      // 店铺设置
      else if (data.sideActiveName == 'setup-shop') {
        return params = 'pannel_store_set'
      }
      // 订单设置
      else if (data.sideActiveName == 'setup-order') {
        return params = 'pannel_deliver_set'
      }
      // 服务订购
      else if (data.routerName == 'setup-service-list') {
        return params = 'pannel_service'
      }  // 订购记录
      else if (data.routerName == 'setup-service-ordered') {
        return params = 'pannel_service_record'
      }



    }



  },

}
